import { Chip } from "@mui/material";
import { colors } from "../../../../ui/colors";
import { getInvoiceStatusLabel, type InvoiceStatus } from "../../utils/getInvoiceStatus";

const statusChipColor = (status: InvoiceStatus) => {
  switch (status) {
    case "UNPAID":
      return { bg: colors.warning?.[100] ?? colors.orange?.[100], color: colors.warning?.[700] ?? colors.orange?.[700] };
    case "PAID":
      return { bg: colors.success?.[100], color: colors.success?.[700] };
    case "REFUNDED":
      return { bg: colors.info?.[100] ?? colors.gray?.[200], color: colors.info?.[700] ?? colors.gray?.[700] };
    case "CANCELLED":
      return { bg: colors.gray?.[200], color: colors.gray?.[700] };
    default:
      return { bg: colors.gray?.[200], color: colors.gray?.[700] };
  }
};

interface InvoiceStatusChipProps {
  status: InvoiceStatus;
}

export const InvoiceStatusChip = ({ status }: InvoiceStatusChipProps) => {
  const { bg, color } = statusChipColor(status);
  return (
    <Chip
      size="small"
      label={getInvoiceStatusLabel(status)}
      sx={{ bgcolor: bg, color, fontWeight: 600, fontSize: "0.7rem" }}
    />
  );
};
